function install(Vue, axios, enableGlobalAuth) {
  Vue.prototype.$calliaAxios = async props => {
    try {
      const tokens = await Vue.prototype.$auth.getTokens();
      props.headers = {
        ...props.headers,
        Authorization: `Bearer ${tokens.accessToken}`,
        "callia-lang": process.env.VUE_APP_PROJECT_CALLIA_LANG || "en-CA"
      };
      return await axios(props);
    } catch (error) {
      console.error("Error in calliaAxios:", error);
      throw error;
    }
  };

  Vue.prototype.$axios = axios;

  if (enableGlobalAuth) {
    axios.interceptors.request.use(
      async function(config) {
        if (
          config.url &&
          config.url.startsWith(process.env.VUE_APP_API_ADMIN_API_ENDPOINT)
        ) {
          try {
            const tokens = await Vue.prototype.$auth.getTokens();
            config.headers["Authorization"] = `Bearer ${tokens.accessToken}`;
            config.headers["callia-lang"] =
              process.env.VUE_APP_PROJECT_CALLIA_LANG || "en-CA";
          } catch (error) {
            console.error("Failed to get tokens in interceptor:", error);
            return Promise.reject(error);
          }
        }

        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
    );

    // Add response interceptor to handle 401 errors
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          console.log("Received 401, token expired, redirecting to login");
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    );
  }

  console.log("init-callia-axios");
}

export default { install };
